import React, { useState, useEffect } from 'react'
import { toast } from 'sonner'

const enquiryStatusOptions = ['enquiry', 'closed', 'admission', 'follow-up']
const initByOptions = ['company', 'client']

const UpdateRecordForm = ({ recordData, onUpdate, onCancel, loading }) => {
  const [formData, setFormData] = useState(recordData)

  useEffect(() => {
    // Jab recordData change ho (yaani naya record update hone ke liye select ho),
    // tab form ke data ko update karo.
    if (recordData) {
      setFormData(recordData)
    }
  }, [recordData])

  const handleInputChange = (e) => {
    const { name, value } = e.target
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }))
  }

  const handleSubmit = (e) => {
    e.preventDefault()
    if (!formData.name.trim()) {
      toast.error('Name is required')
      return
    }
    onUpdate(recordData.id, formData) // Pass ID and updated data to parent handler
  }

  return (
    <form onSubmit={handleSubmit} className='p-4 md:p-6'>
      <div className='grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6'>
        {/* Basic Information */}
        <div className='lg:col-span-3'>
          <h3 className='text-lg font-semibold text-gray-800 mb-4 border-b pb-2'>
            Basic Information
          </h3>
        </div>

        <div>
          <label className='block text-sm font-medium text-gray-700 mb-2'>
            Name *
          </label>
          <input
            type='text'
            name='name'
            value={formData.name}
            onChange={handleInputChange}
            required
            className='w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent'
            placeholder='Enter full name'
          />
        </div>

        <div>
          <label className='block text-sm font-medium text-gray-700 mb-2'>
            Father's Name
          </label>
          <input
            type='text'
            name='father'
            value={formData.father}
            onChange={handleInputChange}
            className='w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent'
            placeholder="Enter father's name"
          />
        </div>

        <div>
          <label className='block text-sm font-medium text-gray-700 mb-2'>
            Parent Number
          </label>
          <input
            type='tel'
            name='parent_number'
            value={formData.parent_number}
            onChange={handleInputChange}
            onKeyPress={(event) => {
              if (!/[0-9]/.test(event.key)) {
                event.preventDefault()
              }
            }}
            className='w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent'
            placeholder='Enter parent contact number'
          />
        </div>

        <div>
          <label className='block text-sm font-medium text-gray-700 mb-2'>
            Mobile
          </label>
          <input
            type='tel'
            name='mobile'
            value={formData.mobile}
            onChange={handleInputChange}
            onKeyPress={(event) => {
              if (!/[0-9]/.test(event.key)) {
                event.preventDefault()
              }
            }}
            className='w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent'
            placeholder='Enter mobile number'
          />
        </div>

        <div className='md:col-span-2'>
          <label className='block text-sm font-medium text-gray-700 mb-2'>
            Address
          </label>
          <input
            type='text'
            name='address'
            value={formData.address}
            onChange={handleInputChange}
            className='w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent'
            placeholder='Enter complete address'
          />
        </div>

        {/* Academic Information */}
        <div className='lg:col-span-3'>
          <h3 className='text-lg font-semibold text-gray-800 mb-4 mt-6 border-b pb-2'>
            Academic Information
          </h3>
        </div>

        <div>
          <label className='block text-sm font-medium text-gray-700 mb-2'>
            Class
          </label>
          <input
            type='text'
            name='class'
            value={formData.class}
            onChange={handleInputChange}
            className='w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent'
            placeholder='Enter class'
          />
        </div>

        <div>
          <label className='block text-sm font-medium text-gray-700 mb-2'>
            Stream/Subject
          </label>
          <input
            type='text'
            name='stream_subject'
            value={formData.stream_subject}
            onChange={handleInputChange}
            className='w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent'
            placeholder='Enter stream or subject'
          />
        </div>

        <div>
          <label className='block text-sm font-medium text-gray-700 mb-2'>
            College/School
          </label>
          <input
            type='text'
            name='collage_school'
            value={formData.collage_school}
            onChange={handleInputChange}
            className='w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent'
            placeholder='Enter college or school name'
          />
        </div>

        {/* Enquiry Information */}
        <div className='lg:col-span-3'>
          <h3 className='text-lg font-semibold text-gray-800 mb-4 mt-6 border-b pb-2'>
            Enquiry Information
          </h3>
        </div>

        <div>
          <label className='block text-sm font-medium text-gray-700 mb-2'>
            Purpose of Visit
          </label>
          <input
            type='text'
            name='purpose_of_visitor'
            value={formData.purpose_of_visitor}
            onChange={handleInputChange}
            className='w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent'
            placeholder='Enter purpose of visit'
          />
        </div>

        <div>
          <label className='block text-sm font-medium text-gray-700 mb-2'>
            Course Enquiry
          </label>
          <input
            type='text'
            name='course_enquiry'
            value={formData.course_enquiry}
            onChange={handleInputChange}
            className='w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent'
            placeholder='Enter course enquiry'
          />
        </div>

        <div>
          <label className='block text-sm font-medium text-gray-700 mb-2'>
            Contact Method
          </label>
          <input
            type='text'
            name='contact_method'
            value={formData.contact_method}
            onChange={handleInputChange}
            className='w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent'
            placeholder='Enter contact method'
          />
        </div>

        <div>
          <label className='block text-sm font-medium text-gray-700 mb-2'>
            Enquiry Status
          </label>
          <select
            name='enquiry_status'
            value={formData.enquiry_status}
            onChange={handleInputChange}
            className='w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent'
          >
            {enquiryStatusOptions.map((option) => (
              <option key={option} value={option}>
                {option.charAt(0).toUpperCase() +
                  option.slice(1).replace('_', ' ')}
              </option>
            ))}
          </select>
        </div>

        <div>
          <label className='block text-sm font-medium text-gray-700 mb-2'>
            About Us Method
          </label>
          <input
            type='text'
            name='about_us_method'
            value={formData.about_us_method}
            onChange={handleInputChange}
            className='w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent'
            placeholder='How did you know about us?'
          />
        </div>

        <div>
          <label className='block text-sm font-medium text-gray-700 mb-2'>
            Initiated By
          </label>
          <select
            name='init_by'
            value={formData.init_by}
            onChange={handleInputChange}
            className='w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent'
          >
            {initByOptions.map((option) => (
              <option key={option} value={option}>
                {option.charAt(0).toUpperCase() + option.slice(1)}
              </option>
            ))}
          </select>
        </div>

        <div className='lg:col-span-3'>
          <label className='block text-sm font-medium text-gray-700 mb-2'>
            Notes
          </label>
          <textarea
            name='note'
            value={formData.note}
            onChange={handleInputChange}
            rows='3'
            className='w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent'
            placeholder='Enter additional notes...'
          ></textarea>
        </div>
      </div>

      <div className='flex flex-col sm:flex-row gap-3 mt-8 pt-6 border-t'>
        <button
          type='submit'
          disabled={loading}
          className='flex-1 bg-green-600 hover:bg-green-700 disabled:bg-green-400 text-white px-6 py-3 rounded-lg font-medium disabled:cursor-not-allowed transition-colors duration-200'
        >
          {loading ? 'Updating...' : 'Update Record'}
        </button>
        <button
          type='button'
          onClick={onCancel}
          className='flex-1 bg-gray-300 hover:bg-gray-400 text-gray-700 px-6 py-3 rounded-lg font-medium transition-colors duration-200'
        >
          Cancel
        </button>
      </div>
    </form>
  )
}

export default UpdateRecordForm
